import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  override overrides: { [key: string]: any } = {};

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    super();

    if (isPlatformBrowser(this.platformId)) {
      this.overrides = {
        swipe: {
          direction: (window as any).Hammer.DIRECTION_ALL,
          threshold: 2,
          velocity: 0.01,
        },
      };
    }
  }
}
